import {
  sendPasswordResetEmail,
  sendEmailVerification,
  type User,
} from "firebase/auth";
import { auth } from "./firebase";

export const resetPassword = async (email: string): Promise<void> => {
  return await sendPasswordResetEmail(auth, email);
};

export const resendVerificationEmail = async (user: User): Promise<void> => {
  return await sendEmailVerification(user, {
    handleCodeInApp: false,
    url: window.location.origin + "/email-sent",
  });
};
